export default {
    accepted_by: "Kim tərəfindən qəbul edilib",
    additional_costs: "Xərclər",
    additional_discount_correction: "Əlavə endirim üçün düzəliş",
    additional_income: "Əlavə gəlir",
    admin_statistics_future: "Gələcək tarixlər üçün yeni girişlər haqqında administrator statistikası",
    administrator_percent: "Administrator faizi",
    administrator_sum: "Administrator məbləği",
    all_visits_of_current_branch_independent_of_status_including_cancelled: "Statusundan asılı olmayaraq bu filiala edilən bütün səfərlər, o cümlədən ləğv edilib",
    apply: "Tətbiq et",
    assistant_percent: "Assistent faizi",
    assistant_sum: "Assistent məbləği",
    average_cheque: "Orta çek",
    average_conversion_per_doctor_per_day: "Həkimlər üzrə gündəlik orta göstərici",
    average_conversion_per_doctor_per_period: "Həkimlər üzrə dövr üçün orta göstərici",
    average_qty_of_goods_in_cheque: "Bir qəbzdə maddələrin orta sayı",
    balance_amount: "Depozitdən ödənilib",
    balance_return: "Depozitin geri qaytarılması",
    became_permanent: "Daimi oldular",
    by: "Kim tərəfindən",
    by_means: "Ödəniş forması üzrə",
    by_services: "Xidmətlər üzrə",
    calculated_from_calendar_visit_duration: "Təqvimə daxil olma müddətindən hesablanır",
    came_again: "Yenidən gəldilər",
    came_among_patients: "Onlardan gələnlər",
    came_later_over_total_primary: "İlk dəfə gələnlərdən təkrar ziyarətçilərin faizi",
    cancel_date: "Ləğv tarixi",
    cancel_reason: "Ləğv səbəbi",
    cancelled_among_them: "Bunlardan ləğv edildi",
    cancelled_visits: "Ləğv edilmiş vizitlər",
    cash_flow_statement: "Pul vəsaitlərinin hərəkəti hesabatı",
    cash_received_report_day_explanation: "Dövr ərzində alınan vəsait: səfərlər üçün ödənişlər (depozit, bonus, zəmanət və s. kimi ödəniş növləri istisna olmaqla) üstəgəl əmanətin doldurulması/çıxarılmasından əldə edilən vəsait",
    cashdesk_report: "Kassa hesabatı",
    conversion: "Konversiya",
    conversion_came_to_permanent: "Konversiya (gəldi -> daimi)",
    cos: "Maya dəyəri",
    cost_of_attracting_primary_patient: "Əsas xəstənin cəlb edilməsinin dəyəri",
    cost_of_materials: "Materialların dəyəri",
    cost_of_visits_for_selected_interval: "Seçilmiş interval ərzində tamamlanan ziyarətlərin dəyəri",
    costs: "Xərclər",
    crm_leads_analytics: "CRM müraciətlərin analitikası",
    curator_id: "Kurator ID",
    curator_name: "Kuratorun adı",
    curator_percent: "Kurator faizi",
    curator_sum: "Kurator məbləği",
    daily_report: "Günlük hesabat",
    debt_payments: "Borc ödənişləri",
    debt_writeoff: "Borcun silinməsi",
    debtor: "Borc sahibi",
    debtors: "Borclular",
    debtors_statement: "Borclular üzrə hesabat",
    deleted_payments_registry: "Silinmiş ödənişlərin reyestri",
    deposit_movements: "Depozit hərəkətləri",
    deposit_reconciliation_report: "Depozitin uzlaşdırılması haqqında akt",
    details_by_visits: "Vizitlər üzrə detallar",
    did_not_came_again: "Yenidən gəlmədilər",
    did_not_come_among_patients: "Onlardan gəlməyənlər",
    doctor_load_percent: "Həkim yüklənmə faizi",
    doctor_name: "Həkim",
    doctor_percent: "Həkim faizi",
    doctor_salary: "Həkim maaşı",
    doctor_statistics: "Həkimlər üzrə statistika",
    doctor_sum: "Həkim məbləği",
    doctors_conversion: "Həkimlər üzrə konversiya",
    doctors_load: "Həkimlərin yüklənməsi",
    duration: "Müddət",
    export_from: "İxrac tarixi",
    exports: "İxracatlar",
    f057: "Forma 057",
    first_visit_date: "İlk vizitin tarixi",
    first_visit_doctor: "İlk vizitin həkimi",
    full_name: "Ad, Soyad",
    general_percent: "Ümumi faiz",
    have_later_visits_independent_of_interval: "Seçilmiş intervaldan asılı olmayaraq gələcək qeydlər var",
    have_later_visits_within_selected_interval: "Seçilmiş intervalda əlavə girişlər var",
    have_no_later_visits_independent_of_interval: "Seçilmiş intervaldan asılı olmayaraq əlavə giriş yoxdur",
    hidden_columns: "Gizli sütunlar",
    hide_cancelled_visits: "Ləğv edilmiş vizitləri gizlət",
    how_much_was_paid_for_visit_for_the_whole_time_independent_of_selected_period: "Seçilmiş hesabat intervalından asılı olmayaraq, bütün vaxt üçün hər ziyarət üçün ödəniş",
    in_progress: "İşlənir",
    includes_both_discount_on_specific_services_and_general_discount: "Xüsusi xidmətlərə endirimlər və səfərdə ümumi endirim daxildir",
    including_adjustment_for_general_visit_discount: "Ümumi ziyarət endirimi üçün düzəliş daxildir",
    including_weighted_average_adjustment_for_general_visit_discount: "Baxış başına ümumi endirim üçün orta çəkili düzəliş daxildir",
    income_by_doctors: "Həkimlər üzrə gəlir",
    income_by_services: "Xidmətlər üzrə gəlir",
    initiator: "Təşəbbüskar",
    invoiced: "Çıxarılan hesablar",
    last_visit_date: "Son vizitin tarixi",
    last_visit_doctor: "Son vizitin həkimi",
    last_visit_recommendation: "Son vizitin tövsiyələri",
    list_of_patients_with_visits_in_this_branch_for_selected_interval: "Seçilmiş interval üçün bu filiala müraciət edən xəstələrin siyahısı",
    margins: "Ümumi mənfəət",
    materials_movement_analytics: "Materialların hərəkət analitikası",
    minutes_visit_was_opened_in_control_system: "Ziyarət protokollarında 'ziyarətlərin başlanğıcı və sonu' nəzarət sistemi açıldı",
    next_visit_date: "Növbəti vizitin tarixi",
    next_visit_doctor: "Növbəti vizitin həkimi",
    number_of_patient_visits_for_given_interval: "Seçilmiş interval üçün xəstə ziyarətlərinin sayı",
    only_fiscal_cheques: "Yalnız fiskal çeklər",
    only_fiscal_payments: "Yalnız fiskal ödənişlər",
    only_paid: "Yalnız ödənilmiş",
    operation_type: "Əməliyyat növü",
    orthodontist: "Ortodont",
    orthopedist: "Ortoped",
    paid_for: "Ödənilən",
    paid_from_account: "Hesabdan ödənilib",
    paid_invoices: "Ödənilmiş hesablar",
    paid_sum: "Ödəniş məbləği",
    patient_deposits: "Xəstə depozitləri",
    patient_id: "Pasiyent ID",
    patient_name: "Pasiyent",
    patient_source: "Xəstə mənbəyi",
    patient_status: "Pasiyent statusu",
    patients_conversion: "Pasiyentlər üzrə konversiya",
    payments_registry: "Ödəniş reyestri",
    payments_within_interval_for_visits_happened_within_interval: "Yalnız seçilmiş interval ərzində baş vermiş səfərlər üçün seçilmiş interval üçün ödənişlərin məbləği",
    payments_within_interval_for_visits_happened_within_interval_excluding_refunds: "Seçilmiş interval üçün yalnız seçilmiş interval ərzində tamamlanan səfərlər üçün ödənişlərin məbləği (geri qaytarılmır)",
    pdf_report: "PDF hesabatı",
    permanent_among_patients: "Onlardan daimi pasiyentlər",
    pl_statement: "Gəlir və xərclər hesabatı",
    plan_treatment_complexes: "Komplekslər",
    plan_treatments: "Müalicə planı",
    previous_visit_date: "Əvvəlki vizitin tarixi",
    price_before_discount: "Endirimdən əvvəl məbləğ",
    primary: "İlkin",
    primary_among_patients: "Onlardan ilkin pasiyentlər",
    primary_marketing_expenses: "İlkin marketinq xərcləri",
    primary_records: "İlkin yazılar",
    primary_records_came: "İlkin yazılar gəldi",
    primary_records_cancelled: "İbtidai - ləğv edildi",
    primary_records_did_not_come: "İlkin yazılar gəlmədi",
    primary_records_further: "İlkin yazılar daha çox yazıldı",
    primary_records_revenue: "İlkin yazılar üzrə gəlir",
    product_name: "Məhsulun adı",
    recorded_later: "Yenidən yazmaq",
    records: "Yazılar",
    records_count: "Vizitlərin sayı",
    refunds_within_interval: "Seçilmiş interval üçün geri ödənişlər",
    repeated: "Təkrar",
    repeated_records: "Təkrar yazılar",
    repeated_records_came: "Təkrar yazılar gəldi",
    repeated_records_cancelled: "Təkrar - ləğv edildi",
    repeated_records_did_not_come: "Təkrar yazılar gəlmədi",
    repeated_records_further: "Təkrar yazılar daha çox yazıldı",
    repeated_records_revenue: "Təkrar yazılar üzrə gəlir",
    report_days_limit: "Hesabat dövrü limiti (günlər)",
    report_is_too_heavy_confirm: "Hesabat səhifədə baxmaq üçün çox böyükdür, hesabatı Excel faylına yükləmək?",
    revenue: "Gəlir",
    revenue_per_hour: "Saat üzrə gəlir",
    revenues: "Gəlirlər",
    revenues_report_day_explanation: "Seçilmiş dövr üçün bütün yollarla ziyarətlər üçün ödənişlər, üstəgəl əlavə gəlir (mühasibat uçotundan) və malların satışından əldə edilən vəsait",
    salary_report: "Əmək haqqı hesabatı",
    saldo: "Saldo",
    sale_date: "Satış tarixi",
    sales_funnel_applications: "Satış huni: Müraciətlər",
    sales_funnel_plans: "Satış huni: Müalicə planları",
    see_all: "Hər kəsi gör",
    see_only_yourself: "Yalnız özünüzə baxın",
    services_amount: "Xidmətlər məbləği",
    show_block_as_free_time: "Blokları boş vaxt kimi göstər",
    show_completed_visits: "Bağlanmış vizitləri göstər",
    show_deleted: "Silinmişləri göstər",
    show_deleted_doctors: "Silinmiş həkimləri göstər",
    show_only_new_patients: "Yalnız yeni pasiyentləri göstər",
    source_of_patient_acquisition: "Xəstə cəlbediciliyinin ilkin mənbəyi",
    source_of_visit_acquisition: "Yaratma mənbəyinə baş çəkin",
    source_type: "Mənbə növü",
    technic_percent: "Texnik faizi",
    technic_sum: "Texnik məbləği",
    therapist: "Terapevt",
    total_acquiring_deductions: "Ümumi ekvayrinq çıxarılması",
    total_cost_of_services: "Xidmətlərin ümumi dəyəri",
    total_materials_deductions: "Ümumi materialların çıxarılması",
    total_patients: "Yazılmış pasiyentlərin sayı",
    total_payments: "Ümumi ödənişlər",
    total_primary: "Cəmi ilkin yazılar",
    total_primary_patients_records: "İbtidai xəstələrin ümumi qeydləri",
    total_revenue: "Ümumi gəlir",
    total_salary: "Ümumi əmək haqqı",
    total_technic_laboratory_deductions: "Ümumi texnik / laboratoriya çıxarılması",
    total_unique_primary_patients: "Ümumi unikal ilkin xəstələr",
    total_with_deductions: "Ümumi çıxarılmalarla birlikdə",
    unique_patients_recorded_during_selected_report_interval: "Seçilmiş hesabat intervalında qeydə alınan unikal xəstələrin sayı",
    unique_patients_with_first_visit_for_interval: "Seçilmiş intervalda ilkin ziyarəti olan unikal xəstələr",
    unpaid_invoices: "Ödənilməmiş hesablar",
    updated_date: "Dəyişdirilmə tarixi",
    visit_id: "Vizit ID",
    visit_price_including_all_discounts: "Bütün endirimlər daxil olmaqla ziyarətin dəyəri",
    visit_statistics: "Vizitlərin statistikası",
    visits_by_source: "Mənbələr üzrə vizitlər",
    visits_cost_over_services_count: "Xidmətlərin sayına görə ziyarətlərin dəyəri",
    visits_detailed: "Vizitlər (detallı)",
    visits_of_current_branch_which_has_services_or_has_status_other_than_not_come: "Xidmətləri qeyd olunan və ya \"gəlmədi\" statusundan başqa statusu olan bu filiala səfərlər",
    visits_of_current_branch_which_have_services_or_have_status_came: "Xidmətlər və ya \"xəstə gəldi\" statusu ilə ziyarətlər",
    visits_price_including_all_discounts: "Bütün endirimlər daxil olmaqla ziyarətlərin dəyəri",
    where_came_from: "Haradan gəlib",
    who_cancelled: "Kim ləğv etdi",
    who_changed_status: "Kim statusu dəyişdi (ödəniş / gəldi)",
    who_created: "Kim tərəfindən yaradılıb",
    who_updated: "Tərəfindən dəyişdirildi",
    with_patient: "Pasiyent ilə",
    worked_days: "İşlənmiş günlər",
    worked_hours: "İşlənmiş saatlar",
    your_report_is_processing: "Hesabatınız hazırlanır. O hazır olduqda sizə bildiriş göndəriləcək."
}
